import React, { Component } from 'react';
import './Features.scss';

class Features extends Component {
  render() {
    return (
      <section id="features" className="features section">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-6 feature text-center">
              <span className="icon icon-tools"></span>
              <div className="feature-content">
                <h5>3D Modelling</h5>
                <p>Cras justo odio, dapibus ac facilisis in, egestas eget quam. Nullam quis risus eget urna mollis ornare vel eu leo. Donec ullamcorper nulla non metus auctor fringilla.</p>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 feature text-center">
              <span className="icon icon-desktop"></span>
              <div className="feature-content">
                <h5>Animating</h5>
                <p>Cras justo odio, dapibus ac facilisis in, egestas eget quam. Nullam quis risus eget urna mollis ornare vel eu leo. Donec ullamcorper nulla non metus auctor fringilla.</p>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 feature text-center">
              <span className="icon icon-lightbulb"></span>
              <div className="feature-content">
                <h5>Texturing</h5>
                <p>Cras justo odio, dapibus ac facilisis in, egestas eget quam. Nullam quis risus eget urna mollis ornare vel eu leo. Donec ullamcorper nulla non metus auctor fringilla.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Features;